<template>
  <b-modal id="timerModal" @ok="$emit('timesup')" hide-header centered no-close-on-backdrop no-close-on-esc>
    <h2>Time's up</h2>
    <template v-slot:modal-footer="{ ok }">
      <b-button size="sm" variant="primary" class="bg-site-primary" @click="ok()">Continue</b-button>
    </template>
  </b-modal>
</template>

<script>
  export default {
    data() {
      return {
        timePassed : 0,
        timerInterval : null,
        timeLimitSeconds : null,
      }
    },
    computed: {
      timeLeft() {
        return this.timeLimitSeconds - this.timePassed;
      },
    },
    watch: {
      timeLeft(newValue) {
        if(newValue == 2 * 60){
          this.$bvToast.toast(`2 minutes remaining`, {
            title: 'Reminder',
            autoHideDelay: 5000,
          })
        }
        else if(newValue == 30){
          this.$bvToast.toast(`30 seconds remaining`, {
            title: 'Reminder',
            autoHideDelay: 5000,
          })
        }
        
        if (newValue <= 0) {
          this.onTimesUp();
        }
      }
    },
    methods: {
      startTimer(timeLimistSeconds) {
        this.clearTimer()
        this.timeLimitSeconds = timeLimistSeconds
        this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
      },
      clearTimer(){
        clearInterval(this.timerInterval)
        this.timePassed= 0
      },
      onTimesUp() {
        clearInterval(this.timerInterval);
        this.$bvModal.show('timerModal')
      },
    },
  }
</script>

<style lang="css" scoped>
.close {
  display:none;
}
</style>